// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TextBannerWrapper_wrapper__JeY_H","wrapper-border-radius":"TextBannerWrapper_wrapper-border-radius__SEth0"};